
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class FactIndexationProfileSecurityDialog extends SiteEntityDialog<FactIndexationProfileSecurityRow, any> {
        protected getFormKey() { return FactIndexationProfileSecurityForm.formKey; }
        protected getIdProperty() { return FactIndexationProfileSecurityRow.idProperty; }
        protected getLocalTextPrefix() { return FactIndexationProfileSecurityRow.localTextPrefix; }
        protected getService() { return FactIndexationProfileSecurityService.baseUrl; }
        protected getDeletePermission() { return FactIndexationProfileSecurityRow.deletePermission; }
        protected getInsertPermission() { return FactIndexationProfileSecurityRow.insertPermission; }
        protected getUpdatePermission() { return FactIndexationProfileSecurityRow.updatePermission; }

        protected form = new FactIndexationProfileSecurityForm(this.idPrefix);

    }
}